import { Component, OnInit } from '@angular/core';
import { BibleBook, BibleBookSection } from '../bible-book/bible-book.component';
import { LanguageService, Language } from '../../services/language.service';
import { BibleBookService } from '../../services/bible-book.service';
import { Localized } from '../../../../objects';
import { ApiService } from '../../../../services/api.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-bible-book-edit',
  templateUrl: './bible-book-edit.component.html',
  styleUrls: ['./bible-book-edit.component.css']
})
export class BibleBookEditComponent implements OnInit {

  public currentLanguageCode = "eng";
  public currentLanguage: Language;

  public item: BibleBook;
  // public languages: Language[];
  public bibleBookSections: BibleBookSection[];
  public currentLocalizedData: Localized;

  constructor(
    private bibleBookSectionSvc: BibleBookService,
    private apiSvc: ApiService,
    private dialog: MatDialogRef<BibleBookEditComponent>
  ) { }

  ngOnInit() {

    this.currentLocalizedData = null;
    if (this.item != null && this.item.Localized != null) {
      this.currentLocalizedData = this.item.Localized[0];
    }

  }

  public setModel(model: BibleBook) {
    this.item = JSON.parse(JSON.stringify(model));

    console.log("New item: ", model, this.item);
  }

  public setSelectedLanguage(language: Language) {

    console.log("setSelectedLangage", language);
    this.currentLanguage = language;
    this.addLocalizationIfNeeded();

  }

  public CurrentLocalizedData(): Localized {

    if (this.currentLanguage == null) {return null;}

    var result = this.item.Localized.filter((item) => {return item.LanguageCode === this.currentLanguage.Code });
    if (result.length === 1) {
     // console.log("LocalizedData Found", result[0]);
      return result[0];
    }

    return null;
  }

  private addLocalizationIfNeeded() {

    if (this.currentLanguage == null) { return; };

    if (this.item.Localized == null) {
      this.initLocalization();
    }

    var localizedData = this.item.Localized.filter((item) => {return item.LanguageCode === this.currentLanguage.Code });

    //console.log("addLocalizationIfNeeded", localizedData, this.currentLanguage.Code);

    if (localizedData.length === 0) {
      this.initLocalization();
    }

  }

  private initLocalization() {
    // console.log("adding new localization");
    if (this.item.Localized == null) {
      this.item.Localized = new Array<Localized>();
    }
     var newData = new Localized();
     newData.LanguageCode = this.currentLanguage.Code;
     this.item.Localized.push(newData);
  }



  public changeSection(sectionId: string) {

    var matchingSection = this.bibleBookSections.filter(s => s.Id === sectionId)[0];
    console.log("Changing section", sectionId, matchingSection);

    this.item.Section = matchingSection;
  }

  public cancel() {
    this.dialog.close();
  }

  public save() {
    console.log(this.item);

    this.apiSvc.post("api/BibleBooks/save", this.item).subscribe(
      (data: BibleBook) => {
        this.item = data;
        console.log(data);

        this.dialog.close(data);
       //this.isLoading = false;
      },
      (err) => {
        console.log("error", err);
      //  this.isLoading = false;
      }
    );
  }


}
